import { useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const AuthCallback = () => {
  const hasProcessed = useRef(false);
  const navigate = useNavigate();
  const { setGoogleUser } = useAuth();

  useEffect(() => {
    // Use ref to prevent double processing in StrictMode
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const processCallback = async () => {
      try {
        const hash = window.location.hash;
        const sessionId = new URLSearchParams(hash.substring(1)).get('session_id');

        if (!sessionId) {
          navigate('/admin', { replace: true });
          return;
        }

        // Exchange session_id for user data + cookie
        const response = await axios.post(
          `${API}/auth/google-session`,
          { session_id: sessionId },
          { withCredentials: true }
        );

        const userData = response.data;
        setGoogleUser(userData);

        // Clear the hash and navigate to dashboard
        window.history.replaceState(null, '', window.location.pathname);
        navigate('/admin/dashboard', { replace: true, state: { user: userData } });
      } catch (error) {
        console.error('Google auth callback failed:', error);
        navigate('/admin', { replace: true });
      }
    };

    processCallback();
  }, [navigate, setGoogleUser]);

  // No visible loading UI — process silently as per playbook
  return null;
};

export default AuthCallback;
